module.exports = __webpack_public_path__ + "img/checked-checkbox.6af7fb7d.svg";